import React, { useState, useEffect } from "react";
import { Table, TableColumn } from "../../../components/table";
import HeaderBar from "../../../components/header/headerBar";
import MainButton from "../../../components/button/mainButton";
import IconMdi from "@mdi/react";
import { mdiPencilCircle, mdiDelete } from "@mdi/js";
import EmptyModel from "../../../components/modal/emptyModal";
import Input from "../../../components/textfield/input";
import Select from "../../../components/select/selectField";
import axios from "axios";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const JobTitle = () => {
  const { confirm } = Modal;
  const [isOpen, setIsOpen] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [dataUnits, setDataUnits] = useState([]);

  const [jobId, setJobId] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [handFee, setHandFee] = useState("");
  const [unit, setUnit] = useState("");

  const columns = [
    {
      title: "",
    },
    {
      title: "ชื่อตำแหน่งงาน",
    },
    {
      title: "ค่ามือ (บาท , %) ",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
      colspan: 2,
    },
  ];

  function onClose() {
    setIsOpen(false);
  }

  const getData = () => {
    axios.get(`/job-titles`).then((res) => {
      console.log("res.data.data =>", res.data.data);
      setJobs(res.data.data);
    });
  };

  const getDataOne = (id: any) => {
    axios.get(`/job-titles/${id}`).then((res) => {
      let data = res.data;
      setJobId(data._id);
      setJobTitle(data.name);
      setHandFee(data.handFee);
      setUnit(data.jobUnit);
    });
  };

  const getDataUnit = () => {
    axios.get(`/job-units`).then((res) => {
      console.log("res.data.data =>", res.data.data);
      let data = res.data.data.map((x: any) => ({
        value: x._id,
        name: x.name,
      }));
      setDataUnits(data);
    });
  };

  const creatData = () => {
    axios
      .post(`/job-titles`, {
        name: jobTitle,
        handFee: handFee,
        jobUnit: unit,
      })
      .then((res) => {
        setTimeout(() => getData(), 200);
        setIsOpen(false);
      });
  };

  const updateData = (id: any) => {
    axios
      .patch(`/job-titles/${id}`, {
        name: jobTitle,
        handFee: handFee,
        jobUnit: unit,
      })
      .then((res) => {
        setTimeout(() => getData(), 200);
        setIsOpen(false);
      });
  };

  function showDeleteConfirm(id: any, name: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${name} ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${name} from list?`}</div>
        </>
      ),
      // content: "Some descriptions",
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        deleteData(id);
      },
      width: "fit-content",
    });
  }

  const deleteData = (id: any) => {
    axios.delete(`/job-titles/${id}`).then((res) => {
      console.log(res.data);
      setTimeout(() => getData(), 200);
    });
  };

  const setCreat = () => {
    setJobTitle("");
    setHandFee("");
    setUnit("");
  };

  useEffect(() => {
    getData();
    getDataUnit();
  }, []);

  return (
    <div>
      <HeaderBar title="JOB TITLE" />
      <EmptyModel show={isOpen} onClose={onClose} width="50%">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "20px 40px",
          }}
        >
          <h4>ตำแหน่งงาน</h4>

          <div className="row justify-center  mt-20">
            <Input
              className="col-8"
              title="ชื่อตำแหน่งงาน"
              value={jobTitle}
              onChange={(e) => {
                setJobTitle(e.target.value);
              }}
            />
          </div>
          <div className="row justify-center mt-20">
            <div className="col-4">
              <Input
                title="ค่ามือ"
                value={handFee}
                onChange={(e) => {
                  setHandFee(e.target.value);
                }}
              />
            </div>
            {/* <div className="col-4">
                <Select
                  className="col-10"
                  title="หน่วย"
                  option={dataUnits}
                />
              </div> */}
            <div className="select col-4">
              <div className="title-input">หน่วย</div>
              <select
                id="cars"
                onChange={(e: any) => {
                  setUnit(e.target.value);
                }}
                value={unit}
              >
                {dataUnits.map((item: any, key: number) => (
                  <option value={item.value} key={key}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="justify-center mt-20">
            <MainButton
              className="mg-10"
              background="#E76464"
              title="ยกเลิก"
              onClick={() => {
                setIsOpen(false);
              }}
            />
            <MainButton
              className="mg-10"
              title="บันทึกข้อมูล"
              onClick={() => {
                jobId ? updateData(jobId) : creatData();
              }}
            />
          </div>
        </div>
      </EmptyModel>
      <div style={{ padding: "10px 40px" }}>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <MainButton
            title="สร้างตำแหน่งงาน"
            onClick={() => {
              setCreat();
              setIsOpen(true);
            }}
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {jobs.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="50%">{item.name}</TableColumn>
                <TableColumn width="15%" align="center">
                  {item.handFee}
                </TableColumn>
                <TableColumn width="5%" align="center">
                  <div
                    onClick={() => {
                      getDataOne(item._id);
                      setIsOpen(true);
                    }}
                  >
                    <IconMdi path={mdiPencilCircle} size="30" color="#5BAEA9" />
                  </div>
                </TableColumn>
                <TableColumn
                  width="5%"
                  align="center"
                  onClick={() => {
                    showDeleteConfirm(item._id, item.name);
                  }}
                >
                  <IconMdi path={mdiDelete} size="25" color="#FF6760"></IconMdi>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default JobTitle;
